import pptxgen from 'pptxgenjs'
import * as export_helper from "./exportHelper";
import quickProtectLogo from "../assets/QuickView_FullLogo.svg"
import titleImage from "../assets/QuickProtect_title_image.png"

class PPTXBuilder{
    constructor(){
        this.pptx = new pptxgen();
        this.pptx_name = 'QuickProtect';
        this.pptx_elements = {
            ticketing: {'graphs':{}, 'tables': {}, 'data_points': {}, section_title: "Review of Tickets & Trends"},
            endpoint_protection: {'graphs':{}, 'tables': {}, 'data_points': {}, section_title: "Endpoint Security Service INSIGHTS"},
            device_monitoring: {'graphs':{}, 'tables': {}, 'data_points': {}, section_title: "Device Monitoring"},
            email_monitoring: {'graphs':{}, 'tables': {}, 'data_points': {}, section_title: "Email Monitoring"}
        }
    }
    set_slide(){
        this.pptx.defineSlideMaster({
            title: "quick_protect_slide",
            background: {color: "#FFFFFF"},
            objects: [
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: quickProtectLogo}},
                { text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#020446', color:'#ffffff', fontSize: 12} } },
                { text: { text: new Date().toString().slice(4, 16), options: { x:'5%', y:'95%', w:'100%', h:'5%', align:'left', color:'#ffffff', fontSize: 8 } } }
            ],
            slideNumber: { x: "90%", y: "95%", color:'#ffffff' }
        })
        this.pptx.defineSlideMaster({
            title: "quick_title_subheader_slide",
            background: {color: "#FFFFFF"},
            objects: [
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: quickProtectLogo}},
                {text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#020446', color:'#ffffff', fontSize: 12} } }
            ]
        })
    }
    get_name(){
        return this.pptx_name;
    }
    set_name(name){
        if(name != '' && name != null) {
            this.pptx_name = name;
        }
    }
    add_element(elementName, element, section, elementType) {
        if(elementType == 'graph')
            this.pptx_elements[section]['graphs'][elementName] = element;
        else if(elementType == 'table') {
            this.pptx_elements[section]['tables'][elementName] = element
        }
        else if(elementType == 'data')
            this.pptx_elements[section]['data_points'][elementName] = element
    }
    add_data_point_element(elementName, element, section, graph) {
        if(!this.pptx_elements[section]['graphs'][graph]) {
            this.pptx_elements[section]['graphs'][graph] = {}
        }
        if(!this.pptx_elements[section]['graphs'][graph]['data_points']) {
            this.pptx_elements[section]['graphs'][graph]['data_points'] = {}
        }
        this.pptx_elements[section]['graphs'][graph]['data_points'][elementName] = {...element, export_key: elementName}
    }
    build(){
        this.set_slide();
        this.add_title_slide();

        let section = 'device_monitoring';
        if(
            Object.keys(this.pptx_elements[section]['graphs']).length === 0 &&
            Object.keys(this.pptx_elements[section]['tables']).length === 0 &&
            Object.keys(this.pptx_elements[section]['data_points']).length === 0
        ){
            return;
        }

        this.add_subtitle_slide(this.pptx_elements[section]['section_title']);
        this.construct_device_monitoring_slide(section);
        // build table element
        for (let table in this.pptx_elements[section]['tables']) {
            this.add_table_slide(this.pptx_elements[section]['tables'][table]);
        }
    }
    add_title_slide(){
        let title_slide = this.pptx.addSlide({masterName: "quick_title_subheader_slide"});
        title_slide.addImage({ x: 0, y: 0, h: '95%', w: '60%', path: titleImage});
        title_slide.addText('Managed Security Service Provider\nINSIGHTS',{x: '60%',y: '15%', w: "40%", h: 3, align: 'center', fontFace: 'Century Gothic', fontWeight: 'Bold', fontSize: 30, color: '#2F5597', bold: true})
    }
    add_subtitle_slide(section_title){
        let title_slide = this.pptx.addSlide({masterName: "quick_title_subheader_slide"});
        title_slide.addImage({ x: 0, y: 0, h: '95%', w: '60%', path: titleImage});
        title_slide.addText(section_title,{x: '60%',y: '15%', w: "40%", h: 3, align: 'center', fontFace: 'Century Gothic', fontWeight: 'Bold', fontSize: 30, color: '#2F5597', bold: true})
    }
    add_data_point_slide(data_point){
        let data_point_slide = this.pptx.addSlide({masterName: "quick_protect_slide"});
        let data_point_text = data_point['stat_title'] + ': ' + data_point['stat_value']
        data_point_slide.addText(data_point_text,{x:1.5,y: 1.8125,w:7,h:2, align: 'center', fontFace: 'Century Gothic', fontSize: 30})
    }
    add_chart_slide(chart, section){
        let slide = this.pptx.addSlide({masterName: "quick_protect_slide"});
        let chartElement = this.pptx_elements[section]['graphs'][chart]
        slide.addText(chartElement['title'],
            {
                x:0 ,y:'0.05',w:'60%',h:'10%',
                align: 'left', fontFace: 'Century Gothic', fontSize: 25, fill:'#020446', color:'#ffffff'
            }
        );
        console.log('chart', chart)
        if(["AgentsByOSMachineType"].includes(chart)){
            slide.addImage({data: chartElement['image'], x: '45%', y: 1.55, h: 2.95, w: 4.95});
        }
        else{
            slide.addImage({data: chartElement['image'], x: '45%', y: 1.91, h: 1.8, w: 4.95});
        }

        if(chartElement['data_points']) {
            let offset = 0
            let ypos = 50;
            if(Object.keys(chartElement['data_points']).length > 1){
                ypos -=5;
            }
            if(Object.keys(chartElement['data_points']).length > 2){
                ypos -=5;
            }
            if(Object.keys(chartElement['data_points']).length > 3){
                ypos -=5;
            }
            if(Object.keys(chartElement['data_points']).length > 4){
                ypos -=5;
            }
            console.log(Object.keys(chartElement['data_points']).length, ypos);
            for(let data_point in chartElement['data_points']) {    
                this.add_data_point(slide, chartElement['data_points'][data_point], ypos, offset)
                offset += 10;
            }
        } else {
            slide.addText("No Data Available", {x:'10%', y:2.53, w:'40%', h:'10%', align: 'left', fontFace: 'Century Gothic', fontSize: 15, bullet: true});
            // slide.addText("placeholder 2", {x:'10%', y:'50%',w:'40%',h:'10%', align: 'left', fontFace: 'Century Gothic', fontSize: 15, bullet: true});
        }
    }
    add_data_point(slide, data_point, y_pos, y_offset){
        let y_position = y_pos + "%"

        if(y_offset)
            y_position = (y_pos+y_offset) + "%"

        let data_point_text = data_point['stat_title'] + ': ' + data_point['stat_value']
        slide.addText(data_point_text, {x:'10%', y: y_position , w: 3.5, align: 'left', fontFace: 'Century Gothic', fontSize: 15, bullet: true});
    }


    build_table_header(raw_header){
        let header = [];
        raw_header.forEach((item) => {
            console.log(item)
            header.push(item['text'])
        })
        console.log(header)
        return header
    }
    build_table_values(raw_header){
        let header = [];
        raw_header.forEach((item) => {
            console.log(item)
            header.push(item['value'])
        })
        console.log(header)
        return header
    }
    
    build_table_body(raw_body, header){
        let statistics_data = [];
        raw_body.forEach((raw_row) => {
            let row = [];
            header.forEach((column) => {
                let cellValue = raw_row[column];
                if (cellValue === null || cellValue === undefined) {
                    row.push('');
                } else {
                    row.push(String(cellValue));
                }
            })
            statistics_data.push(row);
        })
        return statistics_data
    }
    add_table_slide(table) {
        const header_labels = export_helper.build_table_header(table.content.header);
        const header_keys = export_helper.build_table_values(table.content.header);
        const table_body = export_helper.build_table_body(table.content.data, header_keys);
        const maxRowsPerSlide = 12;
        const bodyChunks = [];

        for (let index = 0; index < table_body.length; index += maxRowsPerSlide) {
            bodyChunks.push(table_body.slice(index, index + maxRowsPerSlide));
        }

        if (bodyChunks.length === 0) {
            bodyChunks.push([]);
        }

        bodyChunks.forEach((chunk) => {
            const slide = this.pptx.addSlide({ masterName: "quick_protect_slide" });
            const fullTableData = [header_labels, ...chunk];

            slide.addText("All Devices",
                {
                    x:0, y:0 ,w:'60%',h:'10%',
                    align: 'left', fontFace: 'Century Gothic', fontSize: 25, fill:'#020446', color:'#ffffff'
                }
            );

            slide.addTable(fullTableData, {
                x: '5%',
                y: 1,
                w: '90%',
                rowH: 0.25,
                fontFace: 'Century Gothic',
                fontSize: 6,
                border: { pt: 1, color: '000000' },
            });
        });
    }
    normalize_data_points(dataPoints) {
        if (!dataPoints) {
            return [];
        }

        if (Array.isArray(dataPoints)) {
            return dataPoints.filter(Boolean);
        }

        return Object.keys(dataPoints)
            .sort((a, b) => {
                let aNumber = Number(a);
                let bNumber = Number(b);

                if (!Number.isNaN(aNumber) && !Number.isNaN(bNumber)) {
                    return aNumber - bNumber;
                }

                return a.localeCompare(b);
            })
            .map((key) => dataPoints[key])
            .filter(Boolean);
    }
    normalize_stat_title(title) {
        if (!title) {
            return '';
        }

        return String(title)
            .toLowerCase()
            .replace(/[^a-z0-9]/g, '');
    }
    get_graph_by_keys(section, keys) {
        for (let key of keys) {
            if (this.pptx_elements[section]['graphs'][key]) {
                return this.pptx_elements[section]['graphs'][key];
            }
        }

        return null;
    }
    collect_device_monitoring_stats(section) {
        let dataPoints = this.pptx_elements[section]['data_points'] || {};
        const orderedTitles = [
            'Total Devices',
            'Total Non-Network Devices',
            'Patched Devices',
            'Up-to-Date Antivirus'
        ];

        return orderedTitles
            .filter((title) => dataPoints[title] !== undefined && dataPoints[title] !== null)
            .map((title) => ({
                stat_title: title,
                stat_value: dataPoints[title]
            }));
    }
    format_stat_value(value) {
        if (value === null || value === undefined) {
            return '-';
        }

        if (typeof value === 'number') {
            return Number.isInteger(value) ? this.formatNumber(value) : value.toFixed(2);
        }

        return String(value);
    }
    construct_device_monitoring_slide(section){
        let slide = this.pptx.addSlide({masterName: "quick_protect_slide"});
        let sectionTitle = this.pptx_elements[section]['section_title'] || 'Device Monitoring';
        let devicesByTypeChart = this.get_graph_by_keys(section, ['DevicesByType']);
        let patchStatusChart = this.get_graph_by_keys(section, ['PatchStatus']);
        let antivirusStatusChart = this.get_graph_by_keys(section, ['AntivirusStatus', 'DeviceMonitoringAgentStatus']);
        let stats = this.collect_device_monitoring_stats(section);

        slide.addText(sectionTitle,
                {
                    x:0, y:0 ,w:'60%',h:'10%',
                    align: 'left', fontFace: 'Century Gothic', fontSize: 25, fill:'#020446', color:'#ffffff'
                }
            );

        // let statPositions = [
        //     { x: 0.32, y: 1.30, w: 0.92, h: 0.54, valueFontSize: 15, titleFontSize: 8 },
        //     { x: 1.62, y: 1.30, w: 1.42, h: 0.56, valueFontSize: 15, titleFontSize: 8 },
        //     { x: 0.22, y: 2.10, w: 1.28, h: 0.56, valueFontSize: 15, titleFontSize: 8 },
        //     { x: 1.60, y: 2.10, w: 1.46, h: 0.56, valueFontSize: 15, titleFontSize: 8 }
        // ];

        let statPositions = [
            { x: 0.22, y: 1.05, w: 1.4, h: 0.56, valueFontSize: 15, titleFontSize: 8 },
            { x: 1.62, y: 1.05, w: 1.4, h: 0.56, valueFontSize: 15, titleFontSize: 8 },
            { x: 0.22, y: 2.10, w: 1.4, h: 0.56, valueFontSize: 15, titleFontSize: 8 },
            { x: 1.62, y: 2.10, w: 1.4, h: 0.56, valueFontSize: 15, titleFontSize: 8 }
        ];

        stats.forEach((dataPoint, index) => {
            if (!statPositions[index]) {
                return;
            }

            let value = this.format_stat_value(dataPoint['stat_value']);
            slide.addText(value, {
                x: statPositions[index].x,
                y: statPositions[index].y,
                w: statPositions[index].w,
                h: 0.28,
                align: 'center',
                fontFace: 'Century Gothic',
                fontSize: statPositions[index].valueFontSize || 22,
                bold: true,
                color: '#000000'
            });
            slide.addText(dataPoint['stat_title'], {
                x: statPositions[index].x,
                y: statPositions[index].y + 0.27,
                w: statPositions[index].w,
                h: statPositions[index].h - 0.1,
                align: 'center',
                valign: 'top',
                fontFace: 'Century Gothic',
                fontSize: statPositions[index].titleFontSize || 10,
                color: '#000000'
            });
        });

        if (devicesByTypeChart && devicesByTypeChart['image']) {
            slide.addText(devicesByTypeChart['chart_title'] || devicesByTypeChart['title'] || 'Devices by Type', {
                x: 3.26,
                y: 1.05,
                w: 1.6,
                h: 0.16,
                align: 'left',
                fontFace: 'Century Gothic',
                fontSize: 10,
                bold: true,
                color: '#1F1F1F'
            });
            slide.addImage({
                data: devicesByTypeChart['image'],
                x: 3.28,
                y: 1.22,
                w: 4.50,
                h: 1.74
            });
        }

        if (patchStatusChart && patchStatusChart['image']) {
            slide.addText(patchStatusChart['chart_title'] || patchStatusChart['title'] || 'Patch Status', {
                x: 0.12,
                y: 3.33,
                w: 1.8,
                h: 0.16,
                align: 'left',
                fontFace: 'Century Gothic',
                fontSize: 8,
                bold: true,
                color: '#1F1F1F'
            });
            slide.addImage({
                data: patchStatusChart['image'],
                x: 0.10,
                y: 3.54,
                w: 3.4,
                h: 1.4
            });
        }

        if (antivirusStatusChart && antivirusStatusChart['image']) {
            slide.addText(antivirusStatusChart['chart_title'] || antivirusStatusChart['title'] || 'Antivirus Status', {
                x: 3.77,
                y: 3.33,
                w: 1.8,
                h: 0.16,
                align: 'left',
                fontFace: 'Century Gothic',
                fontSize: 8,
                bold: true,
                color: '#1F1F1F'
            });
            slide.addImage({
                data: antivirusStatusChart['image'],
                x: 3.75,
                y: 3.54,
                w: 3.4,
                h: 1.4
            });
        }

        let notesBoxes = [
            { title: 'Observations:', x: 7.38, y: 1, w: 2.42, h: 2 },
            { title: 'Insights:', x: 7.38, y: 3.2, w: 2.42, h: 2 }
        ];

        notesBoxes.forEach((box) => {
            slide.addShape('rect', {
                x: box.x,
                y: box.y,
                w: box.w,
                h: box.h,
                line: { color: '1F3864', pt: 1.5 },
                fill: { color: 'FFFFFF', transparency: 100 }
            });
            slide.addText(box.title, {
                x: box.x + 0.09,
                y: box.y + 0.10,
                w: box.w - 0.18,
                h: 0.22,
                align: 'left',
                fontFace: 'Century Gothic',
                fontSize: 14,
                bold: true,
                color: '#2F5597'
            });
        });
    }
    // add_table_slide(table){
    //     let slide = this.pptx.addSlide({masterName: "quick_protect_slide"});
    //     let data_head = build_table_header(table['content']['header']);
    //     let data_head_values = build_table_values(table['content']['header']);
    //     let data_body = build_table_body(table['content']['data'], data_head_values);


    //     slide.addTable([data_head],{x:'5%',y:'20%',w:'90%', h:'10%', fontFace: 'Century Gothic', fontSize: 11, fill:'#020446', color:'#ffffff', border:{pt: "1", color: '#000000'}});
    //     slide.addTable(data_body,{x:'5%',y:'30%',w:'90%',autoPage:true, autoPageRepeatHeader:true, autoPageLineWeight:0.5, newSlideStartY: 1, fontFace: 'Century Gothic', fontSize: 7, border:{pt: "1", color: '#000000'}});
    // }
    save(){
        this.pptx.writeFile(this.pptx_name);
    }
    formatNumber(number){
        return number.toLocaleString();
    }
}
export default PPTXBuilder
